module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form donation-form leaf-relief-form",
    attrs: {
      "id": "leaf-relief"
    }
  }, [_c('LeafReliefHeader', {
    attrs: {
      "datalayerName": _vm.datalayerName,
      "counterLimit": _vm.counterLimit,
      "targetText": _vm.targetText,
      "headerText": _vm.headerText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "processing-container"
  }, [(_vm.isProcessing) ? _c('div', {
    staticClass: "processing"
  }, [_c('i', {
    staticClass: "fas fa-sync-alt fa-spin"
  })]) : _vm._e(), _vm._v(" "), (!!_vm.product) ? _c('Stepper', {
    attrs: {
      "petitionSelector": _vm.petitionSelector,
      "donationSelector": _vm.donationSelector,
      "petitionHandle": _vm.petitionHandle,
      "programName": _vm.programName,
      "datalayerName": _vm.datalayerName,
      "thankYouText": _vm.thankYouText,
      "getSocialText": _vm.getSocialText,
      "duplicateEmailMessage": _vm.duplicateEmailMessage,
      "raRgId": _vm.raRgId,
      "raSgId": _vm.raSgId,
      "edoId": _vm.edoId,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showNames) ? _c('div', {
    staticClass: "last-signatures"
  }, [_c('div', {
    staticClass: "ls-title"
  }, [_vm._v("Trees planted")]), _vm._v(" "), _c('LastSignatures', {
    attrs: {
      "campaigId": "leaf-relief",
      "classes": "ra-last-signatures",
      "numberOfSignatures": _vm.numberOfSignatures
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c687b5a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!./~/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./src/components/leaf-relief/LeafRelief.vue
// module id = 708
// module chunks = 0